import React, { Fragment, useEffect, useState } from "react";
import { Button, Col } from "reactstrap";

import { useHistory } from 'react-router-dom'
import { getClientIp } from "./api";

const Landing = () => {
  const [clientIpData, setClientIpData] = useState(null);

    const history = useHistory();

  useEffect(() => {
    getClientIp({ include_threat_score: true })
      .then((response) => {
        const data = response.data;
        setClientIpData(data);
      })
      .catch(console.error);
  }, []);

  return (
    <Fragment>
      <div className="h-100 bg-plum-plate bg-animation">
        <div className="d-flex h-100 justify-content-center align-items-center">
          <Col md="8" className="mx-auto app-login-box">
            <div className="app-logo-inverse mx-auto mb-3" />

            <div className="modal-dialog w-100 mx-auto">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="h5 modal-title text-center">
                    {clientIpData ? (
                      <div>
                        <h4> Your IP: {clientIpData.ip}</h4>
                        <h4> {clientIpData.risk_description}</h4>
                      </div>
                    ) : (
                      <p>Loading...</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center align-items-center">
              <Button
                onClick={() => history.push("/pages/login-boxed")}
                color="primary"
                style={{ width: "100px" }}
              >
                {" "}
                Log in{" "}
              </Button>
            </div>

            <div className="text-center text-white opacity-8 mt-3">
              Copyright &copy; CyberSPF 2023
            </div>
          </Col>
        </div>
      </div>
    </Fragment>
  );
};

export default Landing;
